import { DialogTrigger, Heading } from "react-aria-components";
import { Dialog, Modal, ModalOverlay } from "@/components/application/modals/modal";
import { Button } from "@/components/base/buttons/button";
import { CloseButton } from "@/components/base/buttons/close-button";

// Confirmation for the destructive Team actions (removing access, revoking an
// invite). Both are one click from a row icon, so they get a checkpoint.

type TeamConfirmModalProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void;
  isPending?: boolean;
};

export const TeamConfirmModal = ({
  isOpen,
  onOpenChange,
  title,
  description,
  confirmLabel,
  onConfirm,
  isPending,
}: TeamConfirmModalProps) => (
  <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
    <ModalOverlay isDismissable>
      <Modal className="max-w-md">
        <Dialog>
          <div className="relative w-full overflow-hidden rounded-2xl bg-primary transition-all sm:w-full">
            <CloseButton
              onClick={() => onOpenChange(false)}
              theme="light"
              size="lg"
              className="absolute top-3 right-3"
            />
            <div className="flex flex-col gap-2 px-4 pt-5 mr-4 sm:px-6 sm:pt-6">
              <Heading slot="title" className="text-md font-semibold text-primary">
                {title}
              </Heading>
              <p className="text-sm text-tertiary">{description}</p>
            </div>
            <div className="z-10 flex flex-1 flex-col-reverse gap-3 p-4 pt-6 *:grow sm:grid sm:grid-cols-2 sm:px-6 sm:pt-8 sm:pb-6">
              <Button color="secondary" size="lg" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button color="primary-destructive" size="lg" isLoading={isPending} onClick={onConfirm}>
                {confirmLabel}
              </Button>
            </div>
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  </DialogTrigger>
);
